import React from 'react';
import { element, bool, func, number, object } from 'prop-types';

import { ModalS, ScrollableWrapperS } from './styled-components';

const ModalComp = ({
  isCloseIconOuter,
  children,
  isOpen,
  onClose,
  width,
  style,
}) => isOpen && (
  <ModalS
    {...{
      isCloseIconOuter,
      width,
    }}
    centered
    footer={null}
    visible={isOpen}
    destroyOnClose={isOpen}
    onCancel={onClose}
    maskClosable={false}
    bodyStyle={style}
  >
    <ScrollableWrapperS>
      {children}
    </ScrollableWrapperS>
  </ModalS>
);

ModalComp.propTypes = {
  children: element.isRequired,
  onClose: func.isRequired,
  isOpen: bool.isRequired,
  isCloseIconOuter: bool,
  width: number,
  style: object,
};

ModalComp.defaultProps = {
  isCloseIconOuter: false,
  width: 630,
  style: null,
};

export default ModalComp;



// WEBPACK FOOTER //
// ./src/components/modal/index.js